module.exports = __webpack_public_path__ + "assets/feature3-b197f23e286aaa7218339e88b18dd09c.svg";